'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getClientStorage = () => {
  let clientStorage = null;

  try {
    clientStorage = typeof window === 'object' ? window.localStorage : null;
  } catch (err) {// do nothin'
  }

  return clientStorage;
};

exports.default = getClientStorage;
//# sourceMappingURL=index.js.map
